export const VALID_EMAIL_REGEX = /^[a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,}$/

export const NO_NUMBERS_REGEX = /[0-9]/

export const NO_NUMBERS_OR_SPECIAL_CHARACTERS_REGEX = /[0-9!@#$%^&*()_+{}\]:;<>,.?~\\/-]/

export const ALL_DIGIT_ARE_EQUALS_REGEX = /^(\d)\1{10}$/

export const REMOVE_DOTS_AND_DASHES_REGEX = /[.-]/g

export const CNJ_REGEX = /^[0-9.-]+$/

export const TELEPHONE_MASK_REGEX = /(\d{2})(\d{4})/

export const CELLPHONE_MASK_REGEX = /(\d{2})(\d{5})/

export const ONLY_NUMBER_REGEX = /\D/g

export const ONLY_NUMBERS_AND_LETTERS_REGEX = /[^\w\d]/g

export const PHONE_PREFIX_MASKING_REGEX = /(\d{2})/

export const REGISTRATION_NUMBER_REGEX = /^(\d{2})(\d{3})(\d{4})(\d{2})$/

export const REGISTRATION_NUMBER_VALIDATION_REGEX = /^\d{2}\.\d{3}\/\d{4}-\w{2}$/

export const CPF_NUMBER_REGEX = /^(\d{3})(\d{3})(\d{3})(\d{2})$/

export const CPF_NUMBER_VALIDATION_REGEX = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/

export const RG_NUMBER_REGEX = /^(\d{1,2})(\d{3})(\d{3})(\d{1}|\d{2})$/

export const RG_NUMBER_VALIDATION_REGEX = /^\d{1,2}\.\d{3}\.\d{3}-(\d{1}|\d{2}|[a-z])$/i
